import type { ReactNode } from 'react'
import ShopChromeLayout from '../../src/ssr/layout/ShopChromeLayout'

export default function AboutPageLayout({ children }: { children: ReactNode }) {
  return <ShopChromeLayout>{children}</ShopChromeLayout>
}
